/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import purchaseService from './../../../../services/purchase';
import purchaseStatusService from './../../../../services/purchaseStatus';
import purchaseTransformer from './../../../../transformers/purchase';
import productService from './../../../../services/product';
import warehouseService from './../../../../services/warehouse';
import clientService from './../../../../services/client';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        purchaseNumber: {
          value: '',
          type: 'text',
        },
        comments: {
          value: '',
          type: 'text',
        },
        warehouseId: {
          value: '',
          type: 'select',
        },
        supplierId: {
          value: '',
          type: 'select',
        },
        expectedDeliveryDate: {
          value: '',
          type: 'date',
        },
      }),
      loading: true,
      tabIndex: 'first',
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        qty: {
          value: '0',
          type: 'text',
        },
        purchasePrice: {
          value: '0',
          type: 'text',
        },
        costPrice: {
          value: '0',
          type: 'text',
        },
      },

    };
  },

  computed: {
    ...mapGetters({
      currentStockProducts: 'currentStockProductsCustom',
      warehouses: 'allWarehouses',
      status: 'purchaseStatuses',
      suppliers: 'allClientOptions',
    }),
    additionalData() {
      const Obj = Object.create({});
      Obj.warehouseId = this.formBasicInformation.warehouseId;
      return Obj;
    },
  },

  watch: {
    $route() {
      this.warehouseTarget();
    },

    suppliers(suppliers) {
      this.formBasicInformation.setOptions('supplierId', suppliers.map(c => ({ id: c.id, name: c.companyName || `${c.firstName} ${c.lastName}` })));
    },

    warehouses(warehouses) {
      const data = warehouses.items.filter(item => !item.isSharedToYou);
      this.formBasicInformation.setOptions('warehouseId', data);
    },
    status(status) {
      this.formBasicInformation.setOptions('status', status);
    },
    'formBasicInformation.warehouseId': function (warehouseId) {
      store.dispatch('setStockSelectedWarehouse', warehouseId);
    },
    currentStockProducts: {
      handler(value, oldValue) {
        if (oldValue.length > 0 && value.length > 0) {
          const pruchaseProducts = purchaseTransformer.send(
                Object.assign({}, this.formBasicInformation.data(), { products: value })
              );
          purchaseService.unfinished(pruchaseProducts)
            .then(() => {})
            .catch(() => {});
        }
      },
      deep: true,
    },
  },


  created() {
    this.loading = false;
  },

  methods: {
    destroy() {
      purchaseService.destroyUnfinished()
      .then(() => {
        this.$router.push({ name: 'inventory.transaction.index' });
      })
      .catch(() => {});
    },
    warehouseTarget() {
      const warehouseIds = this.warehouses.items.map(item => (item.id));
      const targeId = this.$router.currentRoute.hash.substring(1);
      if (warehouseIds.indexOf(parseInt(targeId)) !== -1) {
        this.formBasicInformation.setFieldValue('warehouseId', targeId);
      }
    },

    /**
     * Method to store the client
     */
    store(status = 'progress') {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = purchaseTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );
      client.status = status;
      purchaseService.store(client)
      .then(() => {
        this.$message({
          message: this.$t('static.purchase.create.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'inventory.purchase.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formBasicInformation.recordErrors(errors);
        const message = errors.message;
        if (errors.message) {
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
        }
      });
    },
    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },
  },
  mounted() {
    store.dispatch('allCurrentStockProductsCustom', []);
    store.dispatch('setStockSelectedWarehouse', 0);
    Promise.all([
      warehouseService.all(),
      purchaseStatusService.all(),
      purchaseService.showUnfinished(),
      clientService.allOptions('&filter=supplier'),
    ]).then((data) => {
      // store.dispatch('RefreshStockProductsCustom');
      const pur = data[2];
      this.currentPurchase = pur;
      this.formBasicInformation.assignData(pur);
      this.warehouseTarget();
    });
  },
  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VMessage: require('./../../../../components/form/message/message.vue'),
    VProductsTable: require('./../../../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/purchase/create/create.js